import { render, staticRenderFns } from "./home-popup.vue?vue&type=template&id=b8fb292e&scoped=true"
import script from "./home-popup.vue?vue&type=script&lang=js"
export * from "./home-popup.vue?vue&type=script&lang=js"
import style0 from "./home-popup.vue?vue&type=style&index=0&id=b8fb292e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fb292e",
  null
  
)

export default component.exports